<template>
  <vis-login-layout>
    <vis-loading size="md" v-if="loading" logo />
    <vis-loading size="md" v-else-if="redirecting" logo>
      {{ $t('manage.redirecting') }}
    </vis-loading>
    <vis-error
      size="md"
      v-else-if="error"
      with-default
      logo
      back-to-home-event
      :state="state"
      @back-click="onReturn"
    />
    <div
      v-else
      class="ba-w-full xs:ba-w-134 ba-max-h-full ba-m-auto ba-bg-base-strong ba-rounded-md ba-overflow-auto"
    >
      <template v-if="forcedNeedChangePassword">
        <vis-page-manage-password
          :token="token"
          :state="state"
          forced
          :was-password="needChangePassword"
          @back="onReturn"
        />
      </template>
      <template v-else>
        <vis-page-manage-main
          v-if="!currentView"
          :token="token"
          :state="state"
          @navigate="onNavigate"
          @return="onReturn"
        />
        <vis-page-manage-password
          v-if="currentView === 'password'"
          :token="token"
          :state="state"
          :was-password="wasPassword"
          @back="onBack"
        />
      </template>
    </div>
  </vis-login-layout>
</template>

<script>
import VisLoginLayout from "./vis-login-layout";
import VisPageManageMain from "./page-manage/vis-page-manage-main";
import VisPageManagePassword from "./page-manage/vis-page-manage-password";
import { manage2Mixin } from "@ba/visary-account-common-vue";

export default {
  name: "v-page-manage",
  components: {
    VisLoginLayout,
    VisPageManageMain,
    VisPageManagePassword
  },
  mixins: [manage2Mixin]
};
</script>
